export default __webpack_public_path__ + "static/media/resim-yok.39a48983.png";